export const successMessages = {
  userInformationUpdated: "User information updated.",
  userInformationSaved: "User information saved.",
  emailSent: "Email sent!",
  userRemoved: "User removed.",
};
